<template>
  <div id="Orderpage" v-if="orderDetailed && orderDetailed != null">
    <div class="px-4">
      <div class="d-flex justify-space-between align-center">
        <p
          class="profile__container--content__orderhistory--producthistory__order-title"
        >
          {{["Credited", "ReturnChecked", "NewReturn"].includes(orderDetailed.orderStatusId) ? 'Returordre' : 'Ordre'}} #{{ orderDetailed.orderNumber }}
          {{
            statusText(orderDetailed.orderStatusId) === 10
              ? "kansellert"
              : "bestilt"
          }}
          {{ $moment(orderDetailed.createdTime).format("DD.MM.YYYY LT") }}
          {{
            orderDetailed.parentOrderId
              ? "- (Tilknyttet ordre " + orderDetailed.parentOrderNumber + " - "
              : ""
          }}
          <v-hover v-slot="{ hover }">
            <span
              v-show="orderDetailed.parentOrderId"
              @click="redirectOrder()"
              :style="
                hover
                  ? 'cursor: pointer; text-decoration: underline'
                  : 'text-decoration: underline'
              "
              >vis</span
            >
          </v-hover>
        </p>
      </div>
      <p class="title"><b>Produkter</b></p>
      <div>
        <p
          class="profile__container--content__orderhistory--producthistory__order-title__bold mb-0"
        >
          {{['Ordre mottatt', 'Behandles'].includes(statusText(orderDetailed.orderStatusId)) ? 'Sendes fra' : ["Credited", "ReturnChecked", "NewReturn"].includes(orderDetailed.orderStatusId) ? 'Returneres til' : 'Sendt fra'}}
        </p>
      </div>
      <div class="">
        <div
          class="profile__container--content__orderhistory--producthistory__details-info"
        >
          {{ orderDetailed.salonInfo.siteName }}
        </div>
        <div
          class="profile__container--content__orderhistory--producthistory__details-info"
        >
          {{ orderDetailed.salonInfo.address }}
        </div>
        <div
          class="profile__container--content__orderhistory--producthistory__details-info"
        >
          {{ orderDetailed.salonInfo.postalCode }}
          {{ orderDetailed.salonInfo.area }}
        </div>
      </div>
      <div class="mb-4">
        <div
          class="profile__container--content__orderhistory--producthistory__details-info"
        >
          Org.nr. {{ orderDetailed.salonInfo.organizationNumber }}
        </div>
      </div>
      <div
        class="mb-4 profile__container--content__orderhistory--producthistory__status"
      >
        <div
          class="profile__container--content__orderhistory--producthistory__details-title pr-2"
        >
          Status:
        </div>
        <v-chip
          small
          text-color="white"
          :color="statusColor(orderDetailed.orderStatusId)"
          class="profile__container--content__orderhistory--producthistory__chip"
        >
          {{ statusText(orderDetailed.orderStatusId) }}
        </v-chip>
        <span v-if="orderDetailed.trackingNumber && !['Cancelled'].includes(orderDetailed.orderStatusId)" class="ml-2 profile__container--content__orderhistory--producthistory__details-title">
          <b>Sporingsnummer:</b> {{ orderDetailed.trackingNumber }}
        </span>
      </div>
      <div class="mb-4">
        <div
          class="profile__container--content__orderhistory--producthistory__details-title"
        >
          Bestilt av
        </div>
        <div
          class="profile__container--content__orderhistory--producthistory__details-info"
        >
          {{ orderDetailed.invoiceFullName }}
        </div>
        <div
          class="profile__container--content__orderhistory--producthistory__details-info"
        >
          {{ orderDetailed.invoiceAddress }}
        </div>
        <div
          class="profile__container--content__orderhistory--producthistory__details-info"
        >
          {{ orderDetailed.invoicePostNumber }} {{ orderDetailed.invoiceCity }}
        </div>
      </div>
      <div class="mb-4">
        <div
          class="profile__container--content__orderhistory--producthistory__details-title"
        >
          Leveringadresse
        </div>
        <div
          class="profile__container--content__orderhistory--producthistory__details-info"
        >
          {{ orderDetailed.fullName }}
        </div>
        <div
          class="profile__container--content__orderhistory--producthistory__details-info"
        >
          {{ orderDetailed.address }}
        </div>
        <div
          class="profile__container--content__orderhistory--producthistory__details-info"
        >
          {{ orderDetailed.postNumber }} {{ orderDetailed.city }}
        </div>
      </div>
    </div>

    <div v-if="orderDetailed.products.length">
      <order-product-list
        :order="orderDetailed"
        :layout="layout"
      ></order-product-list>
    </div>
    <hr v-if="!['Credited', 'ReturnChecked', 'NewReturn'].includes(orderDetailed.orderStatusId)" class="profile__container--content__orderhistory--producthistory__linebreak my-4"/>
    <div
      v-if="
        orderDetailed.totalDiscount > 0 ||
        (orderDetailed.shippingInfo &&
          !['Credited', 'ReturnChecked', 'NewReturn'].includes(
            orderDetailed.orderStatusId
          ))
      "
    >
    <div class="d-flex align-center justify-space-between px-4 pb-8" v-if="!['Credited', 'ReturnChecked', 'NewReturn'].includes(orderDetailed.orderStatusId)">
      <p
        class="mb-0 profile__container--content__orderhistory--details-price__title"
      >
        Sum produkter
      </p>
      <div class="profile__container--content__orderhistory--details-price">
        <p
          class="mb-0 font-weight-bold"
          :style="
            orderDetailed.orderStatusId === 'Cancelled'
              ? 'text-decoration: line-through;'
              : ''
          "
        >
          {{
            ["Credited", "ReturnChecked", "NewReturn"].includes(
              orderDetailed.orderStatusId
            )
              ? "-" +
                (orderDetailed.total - orderDetailed.orderShippingInclVat)
                  .toFixed(2)
                  .replace(".", ",")
              : (orderDetailed.total - orderDetailed.orderShippingInclVat).toFixed(2).replace(".", ",")
          }}
        </p>
      </div>
    </div>
      <div
        class="d-flex align-center justify-space-between pb-4 px-4"
        v-if="orderDetailed.totalDiscount > 0 && !['Credited', 'ReturnChecked', 'NewReturn'].includes(orderDetailed.orderStatusId)"
      >
        <p
          class="mb-0 profile__container--content__orderhistory--details-price"
        >
          Totalt før rabatter
        </p>
        <div class="profile__container--content__orderhistory--details-price">
          <p class="mb-0">
            {{
              orderDetailed.orderSubtotalInclVat.toFixed(2).replace(".", ",")
            }}
          </p>
        </div>
      </div>
      <div
        class="d-flex align-center justify-space-between px-4"
        v-if="orderDetailed.totalDiscount > 0 && !['Credited', 'ReturnChecked', 'NewReturn'].includes(orderDetailed.orderStatusId)"
      >
        <p
          class="profile__container--content__orderhistory--details-price"
        >
          Rabatter
        </p>
        <div class="profile__container--content__orderhistory--details-price">
          <p>
            -{{ orderDetailed.totalDiscount.toFixed(2).replace(".", ",") }}
          </p>
        </div>
      </div>
      <div class="d-flex align-center justify-space-between px-4" v-if="orderDetailed.shippingInfo || !['Credited', 'ReturnChecked', 'NewReturn'].includes(orderDetailed.orderStatusId)">
        <p class="mb-0" v-if="!['Credited', 'ReturnChecked', 'NewReturn'].includes(orderDetailed.orderStatusId)">
          <b>Leveringsmetode:</b> {{ shippingMethodText(orderDetailed.shippingMethodId) }}
        </p>
        <div class="profile__container--content__orderhistory--details-price" v-if="!['Credited', 'ReturnChecked', 'NewReturn'].includes(orderDetailed.orderStatusId)">
          <p class="mb-0" :style="['Credited', 'Cancelled'].includes(orderDetailed.orderStatusId) ? 'text-decoration: line-through' : ''">
            {{ orderDetailed.shippingInfo.amount.toFixed(2).replace(".", ",") }}
          </p>
        </div>
      </div>

      <hr
        class="profile__container--content__orderhistory--producthistory__linebreak my-4"
      />
    </div>
    <div class="d-flex align-center justify-space-between px-4 mb-2">
      <p
        class="mb-0 profile__container--content__orderhistory--details-price__title"
      >
        Sum totalt
      </p>
      <div class="profile__container--content__orderhistory--details-price">
        <p
          class="mb-0 font-weight-bold"
          :style="
            orderDetailed.orderStatusId === 'Cancelled'
              ? 'text-decoration: line-through;'
              : ''
          "
        >
          {{
            ["Credited", "ReturnChecked", "NewReturn"].includes(orderDetailed.orderStatusId)
              ? "-" + (orderDetailed.total - orderDetailed.orderShippingInclVat).toFixed(2).replace(".", ",")
              : orderDetailed.total.toFixed(2).replace(".", ",")
          }}
        </p>
      </div>
    </div>
    <div
        v-if="paymentMethodText(orderDetailed.paymentMethodId) != '' && !['Credited', 'ReturnChecked', 'NewReturn'].includes(orderDetailed.orderStatusId)"
        class="mb-0 px-4"
      >
        <p
          class="profile__container--content__orderhistory--details mb-0"
        >
          <b>Betalingsmetode:</b>
          {{ paymentMethodText(orderDetailed.paymentMethodId) }}
        </p>
      </div>
    <div
      v-if="showReceiptBtn(orderDetailed.orderStatusId)"
      class="d-flex justify-center"
    >
      <div @click="openReceipt" class="mva-hide d-flex justify-center pb-5">
        <v-btn class="mva-hide" text rounded color="primary">
          <div class="font-weight-bold text-none pr-1">Last ned kvittering</div>
          <v-icon>fxt-external-link</v-icon>
        </v-btn>
      </div>
    </div>
    <div
      class="d-flex justify-center pb-5"
      v-if="orderDetailed.orderStatusId === 'New'"
    >
      <v-btn text rounded color="primary" @click="showCancelOrderDialog = true">
        <div class="font-weight-bold text-none pr-1">Avbestill</div>
        <v-icon>fxt-cancel</v-icon>
      </v-btn>
    </div>
    <div
      class="d-flex justify-center pb-5 px-16 mx-16 pt-5"
      v-if="['Sendt', 'Behandles'].includes(statusText(orderDetailed.orderStatusId)) && orderDetailed.trackingNumber && orderDetailed.trackingNumber !== ''"
    >
      <v-btn outlined block rounded color="primary" @click="openTracking()">
        <div class="font-weight-bold text-none pr-1">Spor pakken</div>
        <v-icon>fxt-external-link</v-icon>
      </v-btn>
    </div>
    <div class="profile__container--navigation__zig-zag mb-10"></div>
    <common-dialog
      v-if="showCancelOrderDialog"
      :show="showCancelOrderDialog"
      :title="`Vil du avbestille ordren?`"
      icon="fxt-cancel"
      buttonTextConfirm="Avbestill"
      buttonIconConfirm="fxt-cancel"
      buttonColorConfirm="error"
      buttonTextColorConfirm="white"
      buttonTextCancel="Behold ordren"
      @closeDialog="showCancelOrderDialog = false"
      @confirmAction="cancelOrder(orderDetailed)"
      :layout="layout"
    >
      <p>
        Produktordren din hos {{ orderDetailed.salonInfo.siteName }} vil
        avbestilles. Er du sikker?
      </p>
    </common-dialog>
  </div>
  <div v-else>
    <v-overlay :value="loading" color="white" absolute style="height: 600px">
      <v-progress-circular
        color="var(--v-primary-base)"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { CommonDialog } from "../../../../Common/CommonComponents";
import OrderProductList from "./OrderProductList.vue";
import ProfileSvc from "../../../../../services/profile-svc";
let profileSvc = null;
import OrderDetailed from "@fixit/fixit-no-header/src/models/OrderDetailed";
import Salon from "@fixit/fixit-no-header/src/models/Salon";
export default {
  components: { OrderProductList, CommonDialog },
  props: {
    layout: {
      required: false,
      default: null,
      type: String,
    },
    user: {
      required: true,
    },
  },
  data: () => ({
    orderDetailed: null,
    salon: null,
    loading: false,
    showDialog: false,
    showCancelOrderDialog: false,
  }),
  computed: {
    bookingApi() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL
        ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL
        : process.env.VUE_APP_FIXIT_NO_BOOKING_URL;
    },
    orderApi() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_ORDER_API_URL
        : this.$config.VUE_APP_FIXIT_ORDER_API_URL
        ? this.$config.VUE_APP_FIXIT_ORDER_API_URL
        : process.env.VUE_APP_FIXIT_ORDER_API_URL;
    },
    orderId() {
      return this.layout == "portal"
        ? this.$route.params.orderId
        : this.$route.query.orderId;
    },
    portalUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_URL
        : this.$config.VUE_APP_FIXIT_NO_URL
        ? this.$config.VUE_APP_FIXIT_NO_URL
        : process.env.VUE_APP_FIXIT_NO_URL;
    },
    allproductsDeleted() {
      for (let product of this.orderDetailed.products) {
        if (!product.isDeleted) {
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    async openReceipt() {
      var pdf = await profileSvc.GetReceiptById(this.orderApi, this.orderId);
      const url = window.URL.createObjectURL(new Blob([pdf]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "kvittering.pdf");
      document.body.appendChild(link);
      link.click();
    },
    redirectOrder() {
      if (this.layout == "chain") {
        this.$router.push({
          query: {
            title: "ProduktOrdredetaljer",
            orderId: this.orderDetailed.parentOrderId,
          },
          params: { order: this.orderDetailed },
        });
      } else {
        this.$router.push({
          name: "ProduktOrdredetaljer",
          params: {
            orderId: this.orderDetailed.parentOrderId,
            order: this.orderDetailed,
          },
        });
      }
    },
    openTracking() {
      window.open(`https://sporing.posten.no/sporing/${this.orderDetailed.trackingNumber}`, '_blank')
    },
    showReceiptBtn(status) {
      if (
        [
          "Sent",
          "Delivered",
        ].includes(status)
      ) {
        return true;
      }
      return false;
    },

    statusText(status) {
      switch (true) {
        case status == "New":
          return "Ordre mottatt";
        case ["Picked", "FinishedPicking", "ReadyForShipment"].includes(status):
          return "Behandles";
        case status == "Sent":
          return "Sendt";
        case status == "Delivered" || status == "NewReturn":
          return "Levert";
        case ["ReturnChecked", "Credited"].includes(status):
          return "Returnert";
        case status == "Cancelled":
          return "Avbestilt";
        default:
          return "";
      }
    },
    // titleText(status) {
    //   switch (true) {
    //     case status == "New":
    //       return "Produktordre mottatt";
    //     case [
    //       "Picked",
    //       "FinishedPicking",
    //       "ReadyForShipment",
    //       "Delivered",
    //       "NewReturn",
    //     ].includes(status):
    //       return "Produktordre behandles";
    //     case ["Sent"].includes(status) &&
    //       this.orderDetailed.trackingNumber != null:
    //       return (
    //         "Produktordre sendt med sporingsnummer " +
    //         this.orderDetailed.trackingNumber +
    //         ":"
    //       );
    //     case ["Sent"].includes(status) &&
    //       this.orderDetailed.trackingNumber == null:
    //       return "Produktordre er sendt";
    //     case ["ReturnChecked", "Credited"].includes(status):
    //       return "Produktordre returnert til:";
    //     case status == "Delivered":
    //       return "Produktordre levert";
    //     case status == "Cancelled":
    //       return "Produktordre avbestilt hos:";
    //     default:
    //       return "";
    //   }
    // },
    statusColor(status) {
      switch (true) {
        case [
          "New",
          "Picked",
          "FinishedPicking",
          "ReadyForShipment",
        ].includes(status):
          return "#472449";
        case ["Delivered", "NewReturn", "ReturnChecked", "Credited", "Sent"].includes(
          status
        ):
          return "#579FA7";
        case status == "Cancelled":
          return "#EA412A";
      }
    },
    paymentMethodText(status) {
      switch (true) {
        case status == "CARD":
          return "Kort";
        case status == "VIPPS":
          return "Vipps";
        case status == "INVOICE":
          return "Faktura";
        case status == "INSTALLMENT":
          return "Delbetaling";
        case status == "VIPPS_DIRECT":
          return "Vipps";
        case status == "KLARNA":
          return "Klarna";
        case status == "APPLE_PAY":
          return "Applepay";
        case status == "GOOGLE_PAY":
          return "Google pay";
        default:
          return "";
      }
    },
    shippingMethodText(methodId) {
      switch (true) {
        case methodId == "2":
          return "Hent på stedet";
        case methodId == "3":
          return "Hent ved behandling";
        case methodId == "5600":
          return "Hjemlevering";
        case methodId == "3584":
          return "Pakke i henteboks";
        case methodId == "5800":
          return "Pakke til hentested";
        default:
          return "";
      }
    },
    async cancelOrder() {
      this.loading = true;
      await profileSvc.CancelOrder(this.orderApi, this.orderId);
      await this.fetchOrder(this.orderId);
      this.loading = false;
      this.showCancelOrderDialog = false;
    },
    async fetchOrder(orderId) {
      this.orderDetailed = await profileSvc.GetOrderDetails(
        this.bookingApi,
        orderId
      );
      this.orderDetailed.orderStatusId = this.allproductsDeleted
        ? "Cancelled"
        : this.orderDetailed.orderStatusId;
    },
  },
  watch: {
    $route(to) {
      if (to.query.orderId != this.orderId) {
        this.fetchOrder(
          this.layout === "portal" ? to.params.orderId : to.query.orderId
        );
      }
    },
  },
  async created() {
    this.loading = true;

    profileSvc = await ProfileSvc(this.$axios);
    await this.fetchOrder(this.orderId);
    let salonResponse = await profileSvc.GetMySalons(
      this.bookingApi,
      this.orderDetailed.siteId,
      "0",
      false
    );
    this.salon = new Salon(salonResponse[0].chainSites[0]);

    this.loading = false;
  },
  beforeDestroy() {
    profileSvc = null;
  },
};
</script>
<style scoped lang="scss">
.title {
  font-size: 18px;
}
</style>
